
import { useEffect } from 'react';

interface InitializationProps {
  loadOnboardingRequests: () => Promise<void>;
  loadEmployees: () => Promise<void>;
  loadSubscribers: () => Promise<void>;
}

export const useDashboardInitialization = ({
  loadOnboardingRequests,
  loadEmployees,
  loadSubscribers
}: InitializationProps) => {
  
  useEffect(() => {
    initializeAdminDashboard();
  }, []);

  const initializeAdminDashboard = async () => {
    await loadOnboardingRequests();
    await loadEmployees();
    await loadSubscribers();
  };

  const handleRefresh = async (activeTab: string) => {
    if (activeTab === "newsletter") {
      await loadSubscribers();
    } else if (activeTab === "verified-clients" || activeTab === "client-requests" || activeTab === "rejected-clients") {
      await loadOnboardingRequests();
    } else if (activeTab === "employees") {
      await loadEmployees();
    }
  };

  return {
    handleRefresh
  };
};
